import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { SunburstGeneral } from "./SunburstGeneral";

export const PieChartProjectLeaders = ({ leaderData = [] }) => {
	const [totalProjects, setTotalProjects] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let total = 0;
		setIsLoading(true);

        leaderData.forEach((leader) => {
            const { children } = leader
            const sumTotal = children.reduce((prev, curren) => {
                return prev + curren.total
            }, 0)
            total += sumTotal
        });
		setTotalProjects(total);
		setIsLoading(false);
	}, [leaderData]);

	if (isLoading) {
		return (
			<div className="flex justify-center items-center sm:w-[320px] sm:h-[320px] md:w-[360px] md:h-[360px] lg:w-[448px] lg:h-[448px]">
				<Spin size="large" />
			</div>
		);
    }

    return (
        <div className="sm:w-[320px] sm:h-[320px] md:w-[360px] md:h-[360px] lg:w-[448px] lg:h-[448px]">
            <SunburstGeneral
                sunbursProps={{
                    data: { name: "Líderes", children: leaderData },
                    borderWidth: 0,
                    cornerRadius: 0,
                    id: "name",
                    value: "total",
                    tooltip: (e) => {
                        const {
                            color = "#ccc",
                            formattedValue = "",
                            data } = e
                        const { label = "N/A" } = data
                        return (
                            <div className="flex items-center gap-2 p-2 bg-white rounded-lg">
                                <div style={{ backgroundColor: color }} className="h-4 w-4" />
                                <div><span>{label}</span></div>
                                <div><span className="font-bold">{formattedValue}</span></div>
                            </div>
                        )
                    },
                    layers: [
                        "arcs",
                        "arcLabels",
                        ({ centerX, centerY }) => (
                            <text
                                x={centerX}
                                y={centerY}
                                textAnchor="middle"
                                dominantBaseline="central"
                                style={{
                                    fontSize: "30px",
                                    fontWeight: 600,
                                }}
                            >
                                {`${Number.parseFloat(totalProjects)} proyectos`}
                            </text>
                        ),
                    ],
                }}
            />
        </div>
    );
};
